/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { RelationshipEvent } from '../model';
/**
 * RelationshipEventApi - axios parameter creator
 * @export
 */
export const RelationshipEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary creates a single relationshipEvent
         * @param {RelationshipEvent} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelationshipEvent: async (data?: RelationshipEvent, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/relationshipEvents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets a single relationshipEvent
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipEvent: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRelationshipEvent', 'id', id)
            const localVarPath = `/navigator/relationshipEvents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the relationshipEvent optionally by relationshipId
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipEvents: async (relationshipId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationshipId' is not null or undefined
            assertParamExists('getRelationshipEvents', 'relationshipId', relationshipId)
            const localVarPath = `/navigator/relationshipEvents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (relationshipId !== undefined) {
                localVarQueryParameter['relationshipId'] = relationshipId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelationshipEventApi - functional programming interface
 * @export
 */
export const RelationshipEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelationshipEventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary creates a single relationshipEvent
         * @param {RelationshipEvent} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelationshipEvent(data?: RelationshipEvent, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRelationshipEvent(data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary gets a single relationshipEvent
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipEvent(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipEvent(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the relationshipEvent optionally by relationshipId
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelationshipEvents(relationshipId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RelationshipEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelationshipEvents(relationshipId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RelationshipEventApi - factory interface
 * @export
 */
export const RelationshipEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelationshipEventApiFp(configuration)
    return {
        /**
         * 
         * @summary creates a single relationshipEvent
         * @param {RelationshipEvent} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelationshipEvent(data?: RelationshipEvent, options?: any): AxiosPromise<RelationshipEvent> {
            return localVarFp.createRelationshipEvent(data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets a single relationshipEvent
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipEvent(id: number, options?: any): AxiosPromise<RelationshipEvent> {
            return localVarFp.getRelationshipEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the relationshipEvent optionally by relationshipId
         * @param {number} relationshipId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelationshipEvents(relationshipId: number, options?: any): AxiosPromise<Array<RelationshipEvent>> {
            return localVarFp.getRelationshipEvents(relationshipId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelationshipEventApi - object-oriented interface
 * @export
 * @class RelationshipEventApi
 * @extends {BaseAPI}
 */
export class RelationshipEventApi extends BaseAPI {
    /**
     * 
     * @summary creates a single relationshipEvent
     * @param {RelationshipEvent} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipEventApi
     */
    public createRelationshipEvent(data?: RelationshipEvent, options?: any) {
        return RelationshipEventApiFp(this.configuration).createRelationshipEvent(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets a single relationshipEvent
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipEventApi
     */
    public getRelationshipEvent(id: number, options?: any) {
        return RelationshipEventApiFp(this.configuration).getRelationshipEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the relationshipEvent optionally by relationshipId
     * @param {number} relationshipId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipEventApi
     */
    public getRelationshipEvents(relationshipId: number, options?: any) {
        return RelationshipEventApiFp(this.configuration).getRelationshipEvents(relationshipId, options).then((request) => request(this.axios, this.basePath));
    }
}
